/* eslint-disable linebreak-style */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from "react";
import { DiscussForm1 } from "parts/DiscussForm1";

import Header1 from "parts/Header1";
import Footer1 from "parts/Footer1";

export const DiscussProjectPage1 = () => {
  const [data, setData] = useState({
    name: "",
    email: "",
    phone: "",
    Message: "",
  });

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const onChange = (event) => {
    setData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value,
    }));
  };

  const resetForm = () => {
    setData({
      name: "",
      email: "",
      phone: "",
      Message: "",
    });
  };

  return (
    <>
      <Header1 />
      <DiscussForm1 data={data} onChange={onChange} resetForm={resetForm} />
      <Footer1 />
    </>
  );
};
